import { render, staticRenderFns } from "./_boardSlug.vue?vue&type=template&id=3261ca20&"
import script from "./_boardSlug.vue?vue&type=script&lang=js&"
export * from "./_boardSlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports